import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { FUNDED_RETURN_TYPES, FUNDING_INSTRUMENTS, FUNDING_RETURN_TYPES, PRICE_TYPES, } from '@fortem-monorepo/constants';
import { baseInstrumentSchema } from './shared/base.schema';
export const diverOtcSchema = baseInstrumentSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.DiverOtc),
    structure_name: z.string().min(1),
    underlying_instrument_id: z.number().int().positive(),
    fund_id: z.number().int().positive(),
    currency_id: z.number().int().positive(),
    counterparty_id: z.number().int().positive(),
    notional: z.number().nullable(),
    trade_id: z.string().nullable(),
    effective_date: z.iso.date(),
    maturity_date: z.iso.date(),
    first_floater_settlement_date: z.iso.date(),
    penultimate_floater_settlement_date: z.iso.date(),
    cash_settlement_payment_date: z.iso.date(),
    funding_instrument: z.enum(FUNDING_INSTRUMENTS).optional().nullable(),
    leverage: z.number(),
    price_type: z.enum(PRICE_TYPES),
    floater_spread_bps: z.number(),
    swap_payments_yearly: z.number().int().positive(),
    funding_return_type: z.enum(FUNDING_RETURN_TYPES),
    funded_return_type: z.enum(FUNDED_RETURN_TYPES),
    bucket_id: z.number().int().positive().optional().nullable(),
});
